(function ($) {
	$.fn.frCustomLimitInitialize = function () {
		return this.each((i, el) => {
			const $self = $(el);
			const options2 = {
				'maxCharacterSize': $self.attr('maxlength'),
				'originalStyle': 'originalTextareaInfo',
				'warningStyle' : 'warningTextareaInfo',
				'warningNumber': 40,
				'displayFormat' : '#input of #max max characters'
			};

			//remove charleft on clone
			$self.parent().find('>.charleft').remove();

			$self.textareaCount(options2);

			//add custom classes
			$self.parent().find('>.charleft').addClass('ginput_counter gfield_description ginput_counter_tinymce atd-nopad');
		});
	}

	$(() => {
		$.initialize('[atd-max-length-element]', function() {
			$(this).frCustomLimitInitialize();
		});
	});
})(jQuery);